import { render } from "./IncubatorAddForm.vue?vue&type=template&id=87d5aa8c"
import script from "./IncubatorAddForm.vue?vue&type=script&lang=js"
export * from "./IncubatorAddForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ckyang/dev/olabbio/sites/olab-github/gf-olab-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__